import "core-js/modules/es.date.to-string.js";
import { parse as dateParser, differenceInYears } from 'date-fns';
import sv from 'date-fns/locale/sv/index';
import { NON_DIGITS_REGEX } from '../regex';
import { FEMALE_NATIONAL_ID, MALE_NATIONAL_ID, INVALID, VALID, CAN_NOT_BE_SANITIZED } from './constants';
var NATIONAL_ID_REGEX = /^(19|20)?[0-9]{6}[0-9]{4}$/;
var SHORT_NATIONAL_ID_LENGTH = 10;
var LONG_NATIONAL_ID_LENGTH = 12;
var sanitizeSwedishNationalId = function sanitizeSwedishNationalId(nationalId) {
  var numbers = nationalId.replace(NON_DIGITS_REGEX, '');
  if (numbers.length === SHORT_NATIONAL_ID_LENGTH) {
    var birthYear = Number.parseInt(numbers.substring(0, 2), 10);

    /*
    NOTICE: This code only affects applicants that ONLY sends two
    digits as their birthyear.
     YYMMDD -> 19YYMMDD (if YY > 20)
    YYMMDD -> 20YYMMDD (else)
     This means that in 2038 (when people born 2020 will be able to
    apply) we'll have to change this treshhold.
    */
    if (birthYear > 20) {
      return "19".concat(numbers);
    }
    return "20".concat(numbers);
  }
  if (numbers.length === LONG_NATIONAL_ID_LENGTH) {
    return numbers;
  }
  return CAN_NOT_BE_SANITIZED;
};

/**
 * Runs the luhn algorithm that is used to calculate if a
 * swedish nationalId is valid
 *
 * This function makes no guarantees on the return value
 * unless the nationalId is first sanitized.
 *
 * @param {string} sanitizedNationalId
 * @return {number} The luhn digit
 */
var getLuhnDigit = function getLuhnDigit(sanitizedNationalId) {
  var nationalId = sanitizedNationalId.substr(-10, 9);
  var chksum = 0;

  // eslint-disable-next-line no-plusplus
  for (var n = 0; n < nationalId.length; n++) {
    var c = +nationalId[n];
    if (n % 2 === 0) {
      chksum += c * 2 > 9 ? c * 2 - 9 : c * 2;
    } else {
      chksum += c;
    }
  }

  // eslint-disable-next-line no-mixed-operators
  return (10 - chksum % 10) % 10;
};
var parse = function parse(nationalId) {
  var result = {
    lastDigits: '',
    birthDate: null,
    gender: '',
    age: null,
    valid: INVALID,
    error: {
      type: 'genericError',
      message: "Invalid national Id: ".concat(nationalId)
    },
    nationalId: {
      "short": '',
      shortDash: '',
      "long": '',
      longDash: ''
    }
  };
  if (!nationalId || !String(nationalId || '').trim()) {
    result.error.type = 'length';
    result.error.message = 'Empty invalid national Id';
    return result;
  }
  var trimmedNationalId = nationalId.trim();
  if (trimmedNationalId.length < 10 || trimmedNationalId.length > 13) {
    result.error.type = 'length';
    result.error.message = "Invalid national Id length: ".concat(nationalId);
    return result;
  }
  var sanitized = sanitizeSwedishNationalId(trimmedNationalId);
  if (!NATIONAL_ID_REGEX.test(sanitized)) {
    return result;
  }
  var luhnDigit = getLuhnDigit(sanitized);
  var lastDigit = Number.parseInt(sanitized.charAt(sanitized.length - 1), 10);
  var hasCorrectChecksum = luhnDigit === lastDigit;
  if (!hasCorrectChecksum) {
    return result;
  }
  var epoch = new Date(0);
  var now = new Date();
  var birthday = sanitized.substring(0, 8);
  var lastDigits = sanitized.substring(8, 12);
  var genderDigit = Number.parseInt(lastDigits.charAt(2), 10);
  var birthDate = dateParser(birthday, 'yyyyMMdd', epoch, {
    locale: sv
  });
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(birthDate)) {
    return result;
  }
  result.lastDigits = lastDigits;
  result.birthDate = birthDate.toISOString();
  result.gender = genderDigit % 2 === 0 ? FEMALE_NATIONAL_ID : MALE_NATIONAL_ID;
  result.age = differenceInYears(now, birthDate);
  result.valid = VALID;
  result.error.type = null;
  result.error.message = null;
  result.nationalId = {
    "short": birthday.substring(2) + lastDigits,
    shortDash: "".concat(birthday.substring(2), "-").concat(lastDigits),
    "long": birthday + lastDigits,
    longDash: "".concat(birthday, "-").concat(lastDigits)
  };
  return result;
};
export default parse;